import axios from "axios";
import { queryParams } from "../../../utils/queryParams";
import { downloadFile } from "../../../utils/downloadFile";

const organizations = axios.create({
  baseURL: queryParams.apiVersion + "admin/organizations"
});

export const organizationsApi = {
  getOrganizations(params) {
    return organizations.get("/", params);
  },
  getSettings(params) {
    return organizations.get("/get_setting_options", params);
  },
  addOrganization(params) {
    return organizations.post("", params);
  },
  updateOrganization(id, params) {
    return organizations.put(`/${id}`, params);
  },
  getOrganizationInfo(params) {
    return organizations.get("/get_organizations_info", params);
  },
  getOrganizationObjects(params) {
    return organizations.get("/get_organization_objects", params);
  },
  exportActive(params) {
    return organizations.post("/export_active", params);
  },
  toggleGlobal2fa(params) {
    return organizations.post("/enable_global_2fa", params);
  },
  removeOrganization(id) {
    return organizations.delete(`/${id}`);
  }
};

export const exportActiveOrganizations = async () => {
  try {
    let res = await organizationsApi.exportActive();

    downloadFile({ data: res.data, fileName: "active_organizations.csv", fileType: "text/csv" });
  } catch (err) {
    console.log(err);
  }
};

export const getOrganizationObjects = async (id) => {
  try {
    let { data } = await organizationsApi.getOrganizationObjects({ params: { id } });
    return data;
  } catch (err) {
    console.log(err);
    return {};
  }
};
